import { Button, Typography } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type DeleteApprovalPolicyDialogProps = {
  overlay: OverlayState
  policyLabel: string
  onDelete: () => void
}

export default function DeleteApprovalPolicyDialog({
  overlay,
  policyLabel,
  onDelete,
}: DeleteApprovalPolicyDialogProps) {
  return (
    <Dialog {...overlay} title="Delete this approval policy?">
      <DialogContent>
        <Typography>
          This will permanently delete the “{policyLabel}” approval policy.
          Documents matching its conditions will no longer require approval
          under it.
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button variant="text" onClick={overlay.close}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            onDelete()
            overlay.close()
          }}
        >
          Delete policy
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
